<template>
  <div id="player" class="cursor-sensitive">
    <div id="p-video" :style="player_style" v-on:click="closePlayer">
      <video
        class="cursor-sensitive"
        id="player-video"
        v-if="src"
        loop=""
        :src="[src]"
      ></video>
    </div>
  </div>
</template>

<script>
let visibilityInterval = null;

export default {
  name: "Player",
  data() {
    return {
      src: "",
      player_style: { opacity: 0 },
    };
  },
  props: {
    video_src: {
      type: String,
      required: false,
    },
    video_type: {
      type: String,
      required: false,
    },
  },
  methods: {
    closePlayer(e) {
      e.preventDefault();
      //this.player_style.opacity = '0';
      //this.$emit('close_player');
      if (this.video_type === 'main-video') {
          document.documentElement.scrollTop = 0;
      }
      this.setUnvisibleAndClose();
    },
    setVisible() {
      console.log("setVisible");
      document.body.classList.add('global-cursor-visible');
      if (visibilityInterval != null) {
        return;
      }
      let $this = this;
      $this.src = $this.video_src;
      visibilityInterval = setInterval(function () {
        if ($this.player_style.opacity >= 1) {
          clearInterval(visibilityInterval);
          visibilityInterval = null;
          $this.$emit("choose_cursor", "close");
          setTimeout(function () {
            //$this.player_style.opacity = '1';
            //$this.player_style.transition = 'opacity 1s';
            let $video = document.getElementById("player-video");
            $video.style.opacity = "1";
            $video.style.transition = "opacity 1s";
            $video.play();
          }, 500);
        } else {
          $this.player_style.opacity += 0.1;
        }
      }, 10);
    },
    setUnvisibleAndClose() {
      console.log("setUnvisibleAndClose");
      if (visibilityInterval != null) {
        return;
      }
      document.getElementById("player-video").pause();
      document.getElementById("player-video").style.opacity = "0";
      let $this = this;
      this.$emit("choose_cursor", "normal");
      setTimeout(function () {
        $this.$emit("close_player");
        document.body.classList.remove('global-cursor-visible');
      }, 1000);
      //$this.player_style.opacity = '0';
      /*
                visibilityInterval = setInterval(function() {
                    if($this.player_style.opacity <= 0) {
                        clearInterval(visibilityInterval);
                        //$this.$emit('close_player');
                    } else {
                        $this.player_style.opacity -= 0.1;
                    }
                }, 1000);*/
    },
  },

  mounted: function () {
    this.setVisible();
  },
  /*updated: function () {
            this.setVisible();
        },*/
};
</script>

<style scoped lang="scss">
#p-video {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  position: fixed;
  background: #1f1f1f;
  opacity: 0;

  video {
    cursor: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;

    position: absolute;

    @media screen and (min-width: 1000px) {
      object-fit: cover;
    }
  }
}
</style>